import React from 'react';
import classNames from 'classnames';
import { AvatarPlaceholder } from 'components/icons';

import './userAvatar.styles.scss';

interface UserAvatarProps {
	photo?: string;
	avatarClass?: string;
}

export const UserAvatar = ({ photo, avatarClass = '' }: UserAvatarProps) => {
	const [useFallback, setUseFallback] = React.useState(false);

	function handleError() {
		setUseFallback(true);
	}

	function handleUpload() {
		setUseFallback(false);
	}

	return !useFallback && photo ? (
		<div
			className={classNames('user-avatar', avatarClass)}
			style={{ backgroundImage: `url(${photo})` }}
		>
			<img
				className="user-avatar__image"
				src={photo}
				alt="Profile"
				onError={handleError}
				onLoad={handleUpload}
			/>
		</div>
	) : (
		<AvatarPlaceholder iconClass={avatarClass} />
	);
};
